var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.526,
    height: 12,
    viewBox: "0 0 12.526 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3006",
    "data-name": "Group 3006",
    transform: "translate(-115.43 -274.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M115.43,283.271c0,.052,0,.1.008.153a2.957,2.957,0,0,0,2.826,2.682,2.746,2.746,0,0,0,1.994-.856l.95-.949a.653.653,0,0,0-.918-.92l-.949.949a1.511,1.511,0,1,1-2.133-2.131l2.833-2.833a1.48,1.48,0,0,1,2.21-.078,1.677,1.677,0,0,1,.25.316.7.7,0,0,0,.556.342.552.552,0,0,0,.588-.592.648.648,0,0,0-.1-.31,3.052,3.052,0,0,0-.463-.589,2.833,2.833,0,0,0-1.969-.862,2.736,2.736,0,0,0-1.994.855l-2.833,2.833a2.737,2.737,0,0,0-.855,1.994Z",
    transform: "translate(0 0.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M119.8,282.158a2.826,2.826,0,0,0,1.968.863,2.744,2.744,0,0,0,2-.856l2.833-2.833a2.737,2.737,0,0,0,.855-2l0-.1,0-.047a2.957,2.957,0,0,0-2.829-2.683,2.75,2.75,0,0,0-2,.855l-.985.985a.629.629,0,0,0,.079.879.617.617,0,0,0,.875.006l.95-.951a1.512,1.512,0,1,1,2.133,2.132l-2.833,2.833a1.642,1.642,0,0,1-1.179.538,1.481,1.481,0,0,1-1.029-.456,1.739,1.739,0,0,1-.25-.318.658.658,0,0,0-.845-.266.583.583,0,0,0-.2.83A3.111,3.111,0,0,0,119.8,282.158Z",
    transform: "translate(0.501 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkicon);
export default __webpack_public_path__ + "static/media/linkicon.d939c4147648dab4fec9e35d042349c5.svg";
export { ForwardRef as ReactComponent };